import React, {FC} from 'react';
import { Styled } from './_styles';
import {Button} from "../Button";

export interface IModalProps {
    title: string;
    description: string;
    onClose: () => void;
    actionTitle?: string;
}

export const Modal:FC<IModalProps> = ({title, description, onClose, actionTitle = "OK"}) => (
        <Styled.ModalWrapper onClick={onClose}>
            <Styled.ModalContent onClick={(e) => e.stopPropagation()}>
                <Styled.ModalInfo>
                    <Styled.ModalTitle>{title}</Styled.ModalTitle>
                    <Styled.ModalDescription>{description}</Styled.ModalDescription>
                </Styled.ModalInfo>
                <Styled.ModalActions>
                    <Button title={actionTitle} onClick={onClose}/>
                </Styled.ModalActions>
            </Styled.ModalContent>
        </Styled.ModalWrapper>
    );